import { Injectable, EventEmitter} from "@angular/core";   //CAP-20457: LOT1.1: Event Emitter called for translation 
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { AppConfig } from '../modules/app.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DPO_CONSTANT } from './../utils/constant';
import { CacheService } from './cache.service';
import { CommonService } from './common.service';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService} from '@ngx-translate/core';   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
// Authnetication Service to handble to authentication
@Injectable()
export class AuthenticationService implements CanActivate {
    languageId: string;                         // DAAS-22 : Translation related changes.
    // Define properties for the service
    private isValidUser: boolean;
    private isValidRole: boolean;
    private isSubsciptionAccessible: boolean = false;
    private isConsultationAccessible: boolean = false;
    rrdiEngineResult: any = {};     			    //CAP-20753 : Declared a list 
    public event: EventEmitter<any> = new EventEmitter();   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON

    constructor(private router: Router,
        private toastrService: ToastrService,
        private cacheService: CacheService,
        private apiconfig :AppConfig,
        private http: HttpClient,
        private commonService: CommonService,
        private translate: TranslateService,   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
        private dialogRef: MatDialog) { }

    // Method to handle the activation of the routes
    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let flag: boolean;
        let routerPath = route.url[0].path;

        //Printing the complete URL
        console.log('Request received as : '+window.location.href);

        //START - CAP_20753:PART-2: POI BASIC AUTH - HEADER EXTRACTION
        let queryParams = route.queryParams;
        var currentURL = location.protocol + "//" + location.host + "/#" + this.apiconfig.apiPath;
        console.log("the url is :" + currentURL);
        this.http.get(currentURL, {observe: 'response', responseType: 'text'}).subscribe(res =>{
            //console.log("midhun---" + res);
            let baseauth =  res.headers.get('Authorization');
            localStorage.setItem(DPO_CONSTANT.CACHE_BASEAUTH, baseauth);
        });
        //STOP - CAP_20753:PART-2: POI BASIC AUTH - HEADER EXTRACTION
        
        this.isValidUser = this.cacheService.getItem(DPO_CONSTANT.CACHE_IS_VALID_USER) ? this.cacheService.getItem(DPO_CONSTANT.CACHE_IS_VALID_USER) : this.isValidUser;
        this.isValidRole = this.cacheService.getItem(DPO_CONSTANT.CACHE_IS_VALID_ROLE) ? this.cacheService.getItem(DPO_CONSTANT.CACHE_IS_VALID_ROLE) : this.isValidRole;
        this.cacheService.setItem(DPO_CONSTANT.CACHE_ACCESS_PATH, routerPath);
        if ((queryParams[DPO_CONSTANT.QP_APPLICATION_NAME] && queryParams[DPO_CONSTANT.QP_USERID] && queryParams[DPO_CONSTANT.QP_USERTYPE] && queryParams[DPO_CONSTANT.QP_RRDI_CODE] && queryParams[DPO_CONSTANT.QP_VIN] && queryParams[DPO_CONSTANT.QP_VIN_BRAND] && queryParams[DPO_CONSTANT.QP_MILEAGE] && queryParams[DPO_CONSTANT.QP_LANGUAGE_ID] && routerPath.toLowerCase() === DPO_CONSTANT.SUBSCRIPTION && queryParams[DPO_CONSTANT.QP_APPLICATION_NAME].toLowerCase() != DPO_CONSTANT.HUB && queryParams[DPO_CONSTANT.QP_APPLICATION_NAME].toLowerCase() != DPO_CONSTANT.PNR) || (queryParams[DPO_CONSTANT.QP_APPLICATION_NAME] && queryParams[DPO_CONSTANT.QP_USERID] && queryParams[DPO_CONSTANT.QP_USERTYPE] && queryParams[DPO_CONSTANT.QP_RRDI_CODE] && queryParams[DPO_CONSTANT.QP_VIN] && queryParams[DPO_CONSTANT.QP_VIN_BRAND] && queryParams[DPO_CONSTANT.QP_MILEAGE] && queryParams[DPO_CONSTANT.QP_LANGUAGE_ID] && queryParams[DPO_CONSTANT.QP_RRDI_BRAND] && queryParams[DPO_CONSTANT.QP_FOLDER_ID] && queryParams[DPO_CONSTANT.QP_CALLBACK_URL] && routerPath.toLowerCase() === DPO_CONSTANT.SUBSCRIPTION && queryParams[DPO_CONSTANT.QP_APPLICATION_NAME].toLowerCase() === DPO_CONSTANT.PNR) ||(queryParams[DPO_CONSTANT.QP_APPLICATION_NAME] && queryParams[DPO_CONSTANT.QP_USERID] && queryParams[DPO_CONSTANT.QP_USERTYPE] && routerPath.toLowerCase() === DPO_CONSTANT.CONSULTATION && queryParams[DPO_CONSTANT.QP_APPLICATION_NAME].toLowerCase() != DPO_CONSTANT.DDC && queryParams[DPO_CONSTANT.QP_APPLICATION_NAME].toLowerCase() != DPO_CONSTANT.POI) || (queryParams[DPO_CONSTANT.QP_APPLICATION_NAME] && queryParams[DPO_CONSTANT.QP_USERID] && queryParams[DPO_CONSTANT.QP_IAMSTRING] && queryParams[DPO_CONSTANT.QP_RRDI_CODE] && routerPath.toLowerCase() === DPO_CONSTANT.CONSULTATION && queryParams[DPO_CONSTANT.QP_APPLICATION_NAME].toLowerCase() === DPO_CONSTANT.POI) || queryParams[DPO_CONSTANT.QP_TOKEN]) {        //CAP-20753: Added different conditions for all mandatory parameters.
            // Authenticate the User based on token
            console.log("Authetication started test");
            this.cacheService.setItem(DPO_CONSTANT.CACHE_QUERY_PARAMS, queryParams);
            let today= new Date();

            /*CAP-20753 : Start  */
            if(queryParams[DPO_CONSTANT.QP_USERID]!= undefined && queryParams[DPO_CONSTANT.QP_APPLICATION_NAME]!= undefined || queryParams[DPO_CONSTANT.QP_USERTYPE]!= undefined){
            this.cacheService.setItem(DPO_CONSTANT.CACHE_USER_ID, queryParams[DPO_CONSTANT.QP_USERID]);
            this.cacheService.setItem(DPO_CONSTANT.CACHE_APPLICATION_NAME, queryParams[DPO_CONSTANT.QP_APPLICATION_NAME]);
            this.cacheService.setItem(DPO_CONSTANT.CACHE_RRDI_CODE, queryParams[DPO_CONSTANT.QP_RRDI_CODE]);
            this.cacheService.setItem(DPO_CONSTANT.CACHE_IAMSTRING, queryParams[DPO_CONSTANT.QP_IAMSTRING]);     //CAP-20753: Set IamString for queryParams
            this.cacheService.setItem(DPO_CONSTANT.CACHE_USER_TYPE, queryParams[DPO_CONSTANT.QP_USERTYPE]);
            }
            /*CAP-20753 : End */


            let isUserValid = <boolean>await this.authenticateByToken(routerPath, localStorage.getItem(DPO_CONSTANT.CACHE_BASEAUTH));
            let uRole = this.cacheService.getItem(DPO_CONSTANT.CACHE_USER_ROLE);
            let applicationName = this.cacheService.getItem(DPO_CONSTANT.CACHE_APPLICATION_NAME);
            if (isUserValid && uRole === DPO_CONSTANT.ROLE_PORT_TECH_USER
                || (routerPath.toLowerCase() === DPO_CONSTANT.SUBSCRIPTION && applicationName.toLowerCase() === DPO_CONSTANT.POI)) {
                /* DAAS-22 : Start- Tranlsation related changes */
                this.languageId = queryParams[DPO_CONSTANT.QP_LANGUAGE_ID];
                console.log("Language Id in delegation is" + this.languageId);
                //CAP-20457: LOT1.1: START  - Translation Service changed to translate for JSON
                let loclang = this.loadDefaultLocale(this.languageId);
                this.translate.use(loclang);
                localStorage.setItem(DPO_CONSTANT.CACHE_I18N_LOCALE, loclang);
                //CAP-20457: LOT1.1: STOP  - Translation Service changed to translate for JSON              
                /* DAAS-22 : End  */
                let isDelegationValid = <boolean>await this.checkDelegation();
                isUserValid = isDelegationValid;
            }
            flag = isUserValid;
        //} else if (this.isValidUser && this.isValidRole) {
         //   flag = true;
        } 
        /* CAP-20753: Start */
        else if (!this.isValidUser && !this.isValidRole){
              flag = false;
            if(window.location.href.includes("subscription") || window.location.href.includes("consultation")){

                if(queryParams[DPO_CONSTANT.QP_TOKEN] === undefined){

                    if(routerPath === DPO_CONSTANT.SUBSCRIPTION && queryParams[DPO_CONSTANT.QP_APPLICATION_NAME] === undefined && queryParams[DPO_CONSTANT.QP_USERID] === undefined && queryParams[DPO_CONSTANT.QP_USERTYPE] === undefined && queryParams[DPO_CONSTANT.QP_TOKEN] === undefined){
                        setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.i18n.error.appname.userid.usertype.token.mandatory'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000)
                    }
                    else if(routerPath === DPO_CONSTANT.CONSULTATION && queryParams[DPO_CONSTANT.QP_APPLICATION_NAME] === undefined && queryParams[DPO_CONSTANT.QP_USERID] === undefined && queryParams[DPO_CONSTANT.QP_USERTYPE] === undefined && queryParams[DPO_CONSTANT.QP_TOKEN] === undefined){
                        setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.i18n.error.appname.userid.usertype.token.mandatory'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000)
                    }
                    else if(queryParams[DPO_CONSTANT.QP_APPLICATION_NAME] === undefined || queryParams[DPO_CONSTANT.QP_APPLICATION_NAME] === '' || queryParams[DPO_CONSTANT.QP_APPLICATION_NAME] === null){
                        setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.i18n.error.appname.mandatory'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000)
                    }
                    else if(queryParams[DPO_CONSTANT.QP_USERID] === undefined || queryParams[DPO_CONSTANT.QP_USERID] === '' || queryParams[DPO_CONSTANT.QP_USERID] === null){
                        setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.i18n.error.userid.mandatory'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000)
                    }else if(routerPath === DPO_CONSTANT.CONSULTATION){
                        if(queryParams[DPO_CONSTANT.QP_APPLICATION_NAME].toLowerCase() === DPO_CONSTANT.DDC){
                            setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.i18n.error.unknown.app.request'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000)
                        }
                        else if(queryParams[DPO_CONSTANT.QP_APPLICATION_NAME].toLowerCase() === DPO_CONSTANT.POI && (queryParams[DPO_CONSTANT.QP_RRDI_CODE] === undefined || queryParams[DPO_CONSTANT.QP_RRDI_CODE] === null || queryParams[DPO_CONSTANT.QP_RRDI_CODE] === '')){
                            setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.i18n.message.err.rrdi'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000);
                        } 
                        else if (queryParams[DPO_CONSTANT.QP_APPLICATION_NAME].toLowerCase() === DPO_CONSTANT.POI && (queryParams[DPO_CONSTANT.QP_IAMSTRING] === undefined || queryParams[DPO_CONSTANT.QP_IAMSTRING] === null || queryParams[DPO_CONSTANT.QP_IAMSTRING] === '')) {
                            setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.i18n.authentication.iamstring.mandatory'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000);
                        }
                        else if(queryParams[DPO_CONSTANT.QP_APPLICATION_NAME].toLowerCase() === DPO_CONSTANT.HUB && (queryParams[DPO_CONSTANT.QP_USERTYPE] === undefined || queryParams[DPO_CONSTANT.QP_USERTYPE] === null || queryParams[DPO_CONSTANT.QP_USERTYPE] === '')){
                            setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.i18n.error.usertype.mandatory'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000)
                        }
                    }
                    else if(routerPath === DPO_CONSTANT.SUBSCRIPTION){
                        
                        if(queryParams[DPO_CONSTANT.QP_APPLICATION_NAME].toLowerCase() === '' || queryParams[DPO_CONSTANT.QP_APPLICATION_NAME].toLowerCase() === DPO_CONSTANT.HUB){
                            setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.i18n.error.unknown.app.request'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000);
                        }
                        if(queryParams[DPO_CONSTANT.QP_APPLICATION_NAME].toLowerCase() === DPO_CONSTANT.POI && (queryParams[DPO_CONSTANT.QP_IAMSTRING] === undefined || queryParams[DPO_CONSTANT.QP_IAMSTRING] === null || queryParams[DPO_CONSTANT.QP_IAMSTRING] === '')){
                            setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.i18n.authentication.iamstring.mandatory'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000)
                        }
                        else if(queryParams[DPO_CONSTANT.QP_RRDI_CODE] === undefined || queryParams[DPO_CONSTANT.QP_RRDI_CODE] === null || queryParams[DPO_CONSTANT.QP_RRDI_CODE] === ''){
                            setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.i18n.message.err.rrdi'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000)
                        }
                        else if(queryParams[DPO_CONSTANT.QP_VIN] === undefined || queryParams[DPO_CONSTANT.QP_VIN] === null || queryParams[DPO_CONSTANT.QP_VIN] === ''){
                            setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.i18n.subscription.vin.mandatory'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000)
                        }
                        else if(queryParams[DPO_CONSTANT.QP_VIN_BRAND] === undefined || queryParams[DPO_CONSTANT.QP_VIN_BRAND] === null || queryParams[DPO_CONSTANT.QP_VIN_BRAND] === ''){
                            setTimeout(() =>{this.toastrService.warning(this.translate.instant('dpo.i18n.subscription.vinbrand.mandatory'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000)
                        }
                        else if(queryParams[DPO_CONSTANT.QP_MILEAGE] === undefined || queryParams[DPO_CONSTANT.QP_MILEAGE] === null || queryParams[DPO_CONSTANT.QP_MILEAGE] === ''){
                            setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.i18n.subscription.mileage.mandatory'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000)
                        }
                        else if(queryParams[DPO_CONSTANT.QP_LANGUAGE_ID] === undefined || queryParams[DPO_CONSTANT.QP_LANGUAGE_ID] === null || queryParams[DPO_CONSTANT.QP_LANGUAGE_ID] === ''){
                            setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.i18n.subscription.language.mandatory'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000)
                        }
                        else if((queryParams[DPO_CONSTANT.QP_USERTYPE] === undefined || queryParams[DPO_CONSTANT.QP_USERTYPE] === null || queryParams[DPO_CONSTANT.QP_USERTYPE] === '')){
                            setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.i18n.error.usertype.mandatory'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000)
                        }
			            else if(queryParams[DPO_CONSTANT.QP_RRDI_BRAND] === undefined || queryParams[DPO_CONSTANT.QP_RRDI_BRAND] === '' || queryParams[DPO_CONSTANT.QP_RRDI_BRAND] === null ){
                            setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.b18n.subscription.rrdibrand.mandatory'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000);
                        }
                        else if(queryParams[DPO_CONSTANT.QP_FOLDER_ID] === undefined || queryParams[DPO_CONSTANT.QP_FOLDER_ID] === '' || queryParams[DPO_CONSTANT.QP_FOLDER_ID] === null ){
                            setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.i18n.subscription.folderid.mandatory'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000);
                        }
                        else if(queryParams[DPO_CONSTANT.QP_CALLBACK_URL] === undefined || queryParams[DPO_CONSTANT.QP_CALLBACK_URL] === '' || queryParams[DPO_CONSTANT.QP_CALLBACK_URL] === null ){
                            setTimeout(() => {this.toastrService.warning(this.translate.instant('dpo.i18n.subscription.callbackurl.manadatory'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,})}, 1000);
                        }
			                      
                    }
                }
            }
            this.unauthenticateUser();
        } else if (this.isValidUser && this.isValidRole) {
            flag = true;
        } 
        /* CAP-20753 :End */
        return flag;
    }

    // Method to handle only authentication of the user
    // DAAS-49 : Added new parameter applicationName; CAP-26096- Added country
    public authenticateUser(role: string, roles: string[], applicationName:string, country: string) {        
        this.isValidUser = true;
        // DAAS-49 : Added new parameters roles and applicationName; CAP-26096- Added country
        this.authenticateByRole(role,roles,applicationName, country).subscribe(isValid => {
            this.isValidRole = isValid;
            this.cacheService.setItem(DPO_CONSTANT.CACHE_IS_VALID_USER, this.isValidUser);
            this.cacheService.setItem(DPO_CONSTANT.CACHE_IS_VALID_ROLE, this.isValidRole);
            this.cacheService.setItem(DPO_CONSTANT.CACHE_USER_ROLE, role);
            this.cacheService.setItem(DPO_CONSTANT.CACHE_USER_ROLES, roles);
            this.cacheService.setItem(DPO_CONSTANT.CACHE_COUNTRY, country);				                 // CAP-26096- Added country
	        this.cacheService.setItem(DPO_CONSTANT.CACHE_APPLICATION_NAME, applicationName);		     // CAP-20753 : Setting the applicationName
            this.event.emit({ languageCode: localStorage.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE) });     //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
        });
    }

    // Method to handle to athentication failure of the user
    public unauthenticateUser() {
        this.isValidUser = false;
        this.isValidRole = false
        this.cacheService.clear();
        this.dialogRef.closeAll();
        this.router.navigate(['/']);
        this.translate.use(DPO_CONSTANT.DEFAULT_LOCALE);   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
	    localStorage.setItem(DPO_CONSTANT.CACHE_I18N_LOCALE, DPO_CONSTANT.DEFAULT_LOCALE);   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
    }

    // CAP-26096_POUDG-8493: Lot-2 related changes
    public reDirectUser() {
        this.isValidUser = false;
        this.isValidRole = false;
        this.dialogRef.closeAll();
        this.router.navigate(['/subscription-validated']);   
        localStorage.setItem(DPO_CONSTANT.CACHE_I18N_LOCALE, localStorage.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE));   
    }

    // CAP-20753 : Method to get the applicationName 
    public getapplicationName() {
        return this.cacheService.getItem(DPO_CONSTANT.CACHE_APPLICATION_NAME);
    } 
    // Common method to get the role of the user
    public getUserRole() {
        return this.cacheService.getItem(DPO_CONSTANT.CACHE_USER_ROLE);
    }

    // Common method to get the all roles linked with the user
    public getUserRoles() {
        return this.cacheService.getItem(DPO_CONSTANT.CACHE_USER_ROLES);
    }

    // Common method to get the subscription screen accessibility
    public checkSubsciptionAccessible() {
        return this.isSubsciptionAccessible;
    }

    // Common method to get the consultation screen accessibility
    public checkConsultationAccessible() {
        return this.isConsultationAccessible;
    }

    // Method to handle the role base authentication for the user
    // DAAS-49 : Added two new parameters applicationName and roles; CAP-26096- Added country
    private authenticateByRole(role: string , roles: string[], applicationName : string, country : string): Observable<boolean> {
        return new Observable(observer => {

            // Get the parameter for the further processing 
            let accessedPath = this.cacheService.getItem(DPO_CONSTANT.CACHE_ACCESS_PATH);
            let queryParams = this.cacheService.getItem(DPO_CONSTANT.CACHE_QUERY_PARAMS);
            let ddc = 'DDC';                    //DAAS-49 : variable declared
            if (role) {
                let flag = false;
                switch (accessedPath) {
                    case DPO_CONSTANT.PATH_SUBSCRIPTION:
                        // Execute the block if user wants the access to subscription screen.
                        if (this.checkMandatoryParameterForSubscription(role,applicationName)) {
                            if (role === DPO_CONSTANT.ROLE_PORT_CCS_MANAGER) {
                                flag = true;
                                this.isSubsciptionAccessible = true;
                                this.isConsultationAccessible = true;
                            } else if (role === DPO_CONSTANT.ROLE_PORT_CCS_USER || role === DPO_CONSTANT.ROLE_PORT_TECH_USER || applicationName.toLowerCase() === DPO_CONSTANT.POI) {
                                flag = true;
                                this.isSubsciptionAccessible = true;
                                this.isConsultationAccessible = false;
                                /* DAAS-49: Start */
                                if (applicationName.toUpperCase() === ddc) {
                                    for (var index in roles) {
                                        if (roles[index] === DPO_CONSTANT.ROLE_PORT_CCS_MANAGER) {
                                            flag = true;
                                            this.isSubsciptionAccessible = true;
                                            this.isConsultationAccessible = true;
                                            }
                                        }
                                    }
                                    /* DAAS-49: End */
                            } else {
                                this.isSubsciptionAccessible = false;
                                this.isConsultationAccessible = false;
                                this.toastrService.warning(this.translate.instant('dpo.i18n.message.access.denied'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
                            }
                        }
                        break;
                    case DPO_CONSTANT.PATH_CONSULTATION:
                        // Execute the block if user wants the access to consultation screen.
                        //CAP-20753 : Checking for user role and for the applicationName 
                        if (this.checkMandatoryParameterForConsultation(role, applicationName)) {
                            if (role === DPO_CONSTANT.ROLE_PORT_CCS_MANAGER || applicationName.toLowerCase() === DPO_CONSTANT.POI ) {
                                flag = true;
                                this.isSubsciptionAccessible = false;
                                this.isConsultationAccessible = true;
                            } else if (role === DPO_CONSTANT.ROLE_PORT_ADMIN || role === DPO_CONSTANT.ROLE_PORT_CONSULT_AP || role === DPO_CONSTANT.ROLE_PORT_CONSULT_AC || role === DPO_CONSTANT.ROLE_PORT_CONSULT_DS || role === DPO_CONSTANT.ROLE_PORT_CONSULT_OV 
			                || role.startsWith(DPO_CONSTANT.ROLE_PORT_CONSULT_AC_CC)
                            || role.startsWith(DPO_CONSTANT.ROLE_PORT_CONSULT_AP_CC)
                            || role.startsWith(DPO_CONSTANT.ROLE_PORT_CONSULT_DS_CC)
                            || role.startsWith(DPO_CONSTANT.ROLE_PORT_CONSULT_OV_CC)) {
                                flag = true;
                                this.isSubsciptionAccessible = false;
                                this.isConsultationAccessible = true;
                            } else if (role === DPO_CONSTANT.ROLE_PORT_CCS_USER) {
                                this.isSubsciptionAccessible = false;
                                this.isConsultationAccessible = false;
                                this.toastrService.warning(this.translate.instant('dpo.i18n.message.access.denied.servicebox'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
                            } else {
                                this.isSubsciptionAccessible = false;
                                this.isConsultationAccessible = false;
                                this.toastrService.warning(this.translate.instant('dpo.i18n.message.access.denied'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
                            }
                        }
                        break;
                    default:
                        // Execute the Default block if user directly go with login page - CAP-26096 Added checks for brand and country bases SA
                        if (role === DPO_CONSTANT.ROLE_PORT_ADMIN || role === DPO_CONSTANT.ROLE_PORT_CONSULT_AP || role === DPO_CONSTANT.ROLE_PORT_CONSULT_AC || role === DPO_CONSTANT.ROLE_PORT_CONSULT_DS || role === DPO_CONSTANT.ROLE_PORT_CONSULT_OV
                            || role.startsWith(DPO_CONSTANT.ROLE_PORT_CONSULT_AC_CC)
                            || role.startsWith(DPO_CONSTANT.ROLE_PORT_CONSULT_AP_CC)
                            || role.startsWith(DPO_CONSTANT.ROLE_PORT_CONSULT_DS_CC)
                            || role.startsWith(DPO_CONSTANT.ROLE_PORT_CONSULT_OV_CC)) {
                            flag = true;
                            this.isSubsciptionAccessible = false;
                            this.isConsultationAccessible = true;
                            this.router.navigate([DPO_CONSTANT.PATH_CONSULTATION], { queryParams: queryParams });
                        } else if (role === DPO_CONSTANT.ROLE_PORT_CCS_MANAGER || role === DPO_CONSTANT.ROLE_PORT_CCS_USER) {
                            this.isSubsciptionAccessible = false;
                            this.isConsultationAccessible = false;
                            this.toastrService.warning(this.translate.instant('dpo.i18n.message.access.denied.servicebox'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
                        } else {
                            this.isSubsciptionAccessible = false;
                            this.isConsultationAccessible = false;
                            this.toastrService.warning(this.translate.instant('dpo.i18n.message.access.denied'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
                        }
                        break;
                }
                return observer.next(flag);
            }
        });
    }

    // Method to call the authentication API based on Token
    private authenticateByToken(routerPath : String, headerParams: String): Promise<boolean> {                //CAP-20753 : Added parameter routerPath
        return new Promise(resolver => {
            setTimeout(() => {
                // Prepare the parameter for API
                let queryParams = this.cacheService.getItem(DPO_CONSTANT.CACHE_QUERY_PARAMS);
                let token = queryParams[DPO_CONSTANT.QP_TOKEN];
                /* Cap-20753 : Start */
                console.log("Authentication Started for SGP");
               let params: any = {
                    userId: this.cacheService.getItem(DPO_CONSTANT.CACHE_USER_ID),
                    applicationName: this.cacheService.getItem(DPO_CONSTANT.CACHE_APPLICATION_NAME),
                    userType: this.cacheService.getItem(DPO_CONSTANT.CACHE_USER_TYPE),
                    rrdi: this.cacheService.getItem(DPO_CONSTANT.CACHE_RRDI_CODE),     //CAP-20753: Added rrdi_code as QueryParams
                    iAmString: this.cacheService.getItem(DPO_CONSTANT.CACHE_IAMSTRING),   //CAP-20753: Added IAMString as QueryParams
                    requestFor:routerPath                                                  //CAP-20753 : Added routerPath as query parameter
                    //token : queryParams[DPO_CONSTANT.QP_TOKEN]
                };
                /* CAP-20753 :End */
                
                // Call Decode API
                this.commonService.authenticateToken(params,token,headerParams).subscribe(response => {                          //CAP-20753 : Passed params in function
                    let flag = false;
                    if (response) {
                        this.cacheService.setItem(DPO_CONSTANT.CACHE_USER_ID, response['userName']);
                        this.cacheService.setItem(DPO_CONSTANT.CACHE_USER_TYPE, response['userType']);              // CAP-20753 : Added the userType in Response
                        this.cacheService.setItem(DPO_CONSTANT.CACHE_APPLICATION_NAME, response['appName']);        // CAP-20753 : Added the applicationName in response 
                        this.cacheService.setItem(DPO_CONSTANT.CACHE_COUNTRY, response['country']);                 //CAP-26096 : Added country
                        this.authenticateUser(response['userRole'],  response['userRoles'],response['appName'], response['country']);   //CAP-26096 : Added country
                        if (this.isValidUser && this.isValidRole) {
                            flag = true;
                        }
                    }
                    return resolver(flag);
                }, error => {
                    if (error && error.status && (error.status === 400 || error.status === 401 || error.status === 403 || error.status === 503) && error.error) {
                        this.toastrService.warning(this.translate.instant(error.error), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
                    } else {
                        this.toastrService.error(this.translate.instant('dpo.i18n.message.record.error'), this.translate.instant('dpo.i18n.message.toastr.error'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
                    }
                    this.unauthenticateUser();
                });
            }, 500);
        });
    }

    // Method to call the check delogation API
    private checkDelegation(): Promise<boolean> {
        return new Promise(resolver => {
            let flag = false;
            // Prepare the parameter for API
            let queryParams = this.cacheService.getItem(DPO_CONSTANT.CACHE_QUERY_PARAMS);
            let params: any = {
                rrdi: queryParams[DPO_CONSTANT.QP_RRDI_CODE] ? queryParams[DPO_CONSTANT.QP_RRDI_CODE].trim() : '',
                brand: queryParams[DPO_CONSTANT.QP_VIN_BRAND] ? queryParams[DPO_CONSTANT.QP_VIN_BRAND].trim() : '',
                userId: this.cacheService.getItem(DPO_CONSTANT.CACHE_USER_ID) ? this.cacheService.getItem(DPO_CONSTANT.CACHE_USER_ID) : '' ,        
                applicationName: this.cacheService.getItem(DPO_CONSTANT.CACHE_APPLICATION_NAME) ? this.cacheService.getItem(DPO_CONSTANT.CACHE_APPLICATION_NAME) : '',      // CAP-20753 : Added params applicationName
                userType: this.cacheService.getItem(DPO_CONSTANT.CACHE_USER_TYPE) ? this.cacheService.getItem(DPO_CONSTANT.CACHE_USER_TYPE) : ''                            // CAP-20753 : Added params userType
            };
            // Call delegation API
            this.commonService.authenticateDelegation(params).subscribe(response => {
                let payerType :string;                  // CAP-20753 : Added payerType
                this.rrdiEngineResult = response;       // CAP-20753 : Added response to list
                if (response) {
                    flag = true;
                }
                return resolver(flag);
            }, error => {
                if (error && error.status && (error.status === 400 || error.status === 404) && error.error) {
                    this.toastrService.warning(this.translate.instant(error.error), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
                } else {
                    this.toastrService.error(this.translate.instant('dpo.i18n.message.record.error'), this.translate.instant('dpo.i18n.message.toastr.error'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
                }
                return resolver(flag);
            });
        });
    }

    // CAP-20753 : applicationName is passed in Method to check the mandatory parameters for Subscription screen.
    private checkMandatoryParameterForSubscription(role: string , applicationName: string): boolean {
        let mandatoryParamterList: string[] = [];
        let queryParams = this.cacheService.getItem(DPO_CONSTANT.CACHE_QUERY_PARAMS);
        if (queryParams) {
            if (!queryParams[DPO_CONSTANT.QP_RRDI_CODE]) {
                mandatoryParamterList.push(DPO_CONSTANT.QP_RRDI_CODE);
            }
            if (!queryParams[DPO_CONSTANT.QP_VIN]) {
                mandatoryParamterList.push(DPO_CONSTANT.QP_VIN);
            }
            if (!queryParams[DPO_CONSTANT.QP_VIN_BRAND]) {
                mandatoryParamterList.push(DPO_CONSTANT.QP_VIN_BRAND);
            }
            if (!queryParams[DPO_CONSTANT.QP_MILEAGE]) {
                mandatoryParamterList.push(DPO_CONSTANT.QP_MILEAGE);
            }
            if (!queryParams[DPO_CONSTANT.QP_LANGUAGE_ID]) {
                mandatoryParamterList.push(DPO_CONSTANT.QP_LANGUAGE_ID);
            }
            if (role === DPO_CONSTANT.ROLE_PORT_CCS_MANAGER || role === DPO_CONSTANT.ROLE_PORT_CCS_USER) {
                // Check the mandatory parameters for CCS user and CCS manager.
                if (!queryParams[DPO_CONSTANT.QP_RRDI_BRAND]) {
                    mandatoryParamterList.push(DPO_CONSTANT.QP_RRDI_BRAND);
                }
                if (!queryParams[DPO_CONSTANT.QP_FOLDER_ID]) {
                    mandatoryParamterList.push(DPO_CONSTANT.QP_FOLDER_ID);
                }
                if (!queryParams[DPO_CONSTANT.QP_CALLBACK_URL]) {
                    mandatoryParamterList.push(DPO_CONSTANT.QP_CALLBACK_URL);
                }    
            }
        }
        if (mandatoryParamterList && mandatoryParamterList.length === 0) {
            return true;
        } else {
            this.toastrService.error(this.translate.instant('dpo.i18n.message.subscription.mandatory.parameter') + ' : ' + mandatoryParamterList, this.translate.instant('dpo.i18n.message.toastr.error'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
            return false;
        }
    }

    // Method to check the mandatory parameters for Consultation screen.
    // CAP-20753 : check for the applicationName in mandatory params 
    private checkMandatoryParameterForConsultation(role: string, applicationName: string): boolean {
        let mandatoryParamterList: string[] = [];
        let queryParams = this.cacheService.getItem(DPO_CONSTANT.CACHE_QUERY_PARAMS);
        if (queryParams) {
            if (role === DPO_CONSTANT.ROLE_PORT_CCS_MANAGER || applicationName.toLowerCase() === DPO_CONSTANT.POI ) {
                if (!queryParams[DPO_CONSTANT.QP_RRDI_CODE]) {
                    mandatoryParamterList.push(DPO_CONSTANT.QP_RRDI_CODE);
                }
            }
        }
        if (mandatoryParamterList && mandatoryParamterList.length === 0) {
            return true;
        } else {
            this.toastrService.error(this.translate.instant('dpo.i18n.message.consultation.mandatory.parameter.ccsManager'), this.translate.instant('dpo.i18n.message.toastr.error'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
            return false;
        }
    }
   //CAP-20457: LOT1.1: START - ADDED DEFAULT LOCALE EDITOR + Translation Service changed to translate for JSON

    public loadDefaultLocale(locale: string):string{

        var nwlocale = undefined;
        if (locale.length < 5) {
            nwlocale = locale;
        } else {
            var partsOfStr = locale.split('-');
            nwlocale=partsOfStr[0];
        }
        let dfLocale =DPO_CONSTANT.DEFAULT_LOCALE;
        switch (nwlocale) {
            case 'ar':
                dfLocale='ar-AE';
                break;
                
            case 'bg':
                dfLocale='bg-BG';
                break;  
                
            case 'cs':
                dfLocale='cs-CZ';
                break;
            case 'da':
                dfLocale='da-DK';
                break;
                    
            case 'de':
                dfLocale='de-DE';
                break;
            case 'el':
                dfLocale='el-GR';
                break;
                        
            case 'en':
                dfLocale='en-GB';
                break;
            case 'es':
                dfLocale='es-ES';
                break;
                            
            case 'et':
                dfLocale='et-EE';
                break;
            case 'fi':
                dfLocale='fi-FI';
                break;
                                
            case 'fr':
                dfLocale='fr-FR';
                break;
            case 'hr':
                dfLocale='hr-HR';
                break;

                                    
            case 'hu':
                dfLocale='hu-HU';
                break;
            case 'it':
                dfLocale='it-IT';
                break;
                                        
            case 'ja':
                dfLocale='ja-JP';
                break;
            case 'ko':
                dfLocale='ko-KR';
                break;
                                            
            case 'it':
                dfLocale='it-LT';
                break;
            case 'lv':
                dfLocale='lv-LV';
                break;
                                                
            case 'nl':
                dfLocale='nl-NL';
                break;
            case 'no':
                dfLocale='nn-NO';
                break;
                                                    
            case 'pl':
                dfLocale='pl-PL';
                break;
            case 'pt':
                dfLocale='pt-PT';
                break;
                                                        
            case 'ro':
                dfLocale='ro-RO';
                break;  
            case 'ru':
                dfLocale='ru-RU';
                break;
                                                            
            case 'sk':
                dfLocale='sk-SK';
                break;
            case 'sl':
                dfLocale='sl-SL';
                break;
                                                                
            case 'sv':
                dfLocale='sv-SE';
                break;
            case 'tr':
                dfLocale='tr-TR';
                break;
                

        }
        return dfLocale;
    }
    //CAP-20457: LOT1.1: STOP - ADDED DEFAULT LOCALE EDITOR + Translation Service changed to translate for JSON
}
